import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    document.querySelectorAll(".c-main-search__select").forEach((item) => {
      this.selectItems = [];
      this.selectItems.push(new Choices(item, {
        searchEnabled: false,
        itemSelectText: '',
        dropdownDirection: "down"
      }));
    });

    let _this = this;

    const selectElement = document.getElementsByClassName('auto-submit');
    selectElement.forEach((item)=> {
      item.addEventListener('change', function (event) {
        window.location.href = (_this.updateURLParameter(window.location.href, this.name, this.value));
      });
    })
  }

  updateURLParameter(url, param, paramVal){
    var newAdditionalURL = "";
    var tempArray = url.split("?");
    var baseURL = tempArray[0];
    var additionalURL = tempArray[1];
    var temp = "";
    if (additionalURL) {
        tempArray = additionalURL.split("&");
        for (var i=0; i<tempArray.length; i++){
            if(tempArray[i].split('=')[0] != param){
                newAdditionalURL += temp + tempArray[i];
                temp = "&";
            }
        }
    }
  
    var rows_txt = temp + "" + param + "=" + paramVal;
    return baseURL + "?" + newAdditionalURL + rows_txt;
  }

  disconnect() {
    if(this.selectItems) {
      this.selectItems.forEach((item) => {
        if(item){
          item.destroy();
        }
      });
    }
  }
}